export default __webpack_public_path__ + "static/gilroy-bold-e6853a113dff25d8fe652732a5b0d2e2.eot";